// extracted by mini-css-extract-plugin
export default {"chip":"ProgresoFicha_chip__HrkpM","progress":"ProgresoFicha_progress__aO8ov"};